import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
export interface LinkWrapperProps {
  href: string | null;
  isExternal: boolean;
  fillHeight?: boolean;
  children: React.ReactNode;
}
export const LinkWrapper: React.FC<LinkWrapperProps> = t0 => {
  const $ = _c(17);
  const {
    href,
    isExternal,
    fillHeight,
    children
  } = t0;
  const heightClass = fillHeight ? "h-full" : "";
  const blockClass = fillHeight ? "block h-full" : "block";
  if (!href) {
    let t1;
    if ($[0] !== children || $[1] !== heightClass) {
      t1 = <section className={heightClass}>{children}</section>;
      $[0] = children;
      $[1] = heightClass;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (isExternal) {
    let t1;
    if ($[3] !== blockClass || $[4] !== children || $[5] !== href) {
      t1 = <a href={href} target="_blank" rel="noopener noreferrer" className={blockClass}>{children}</a>;
      $[3] = blockClass;
      $[4] = children;
      $[5] = href;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    let t2;
    if ($[7] !== heightClass || $[8] !== t1) {
      t2 = <section className={heightClass}>{t1}</section>;
      $[7] = heightClass;
      $[8] = t1;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t1;
  if ($[10] !== blockClass || $[11] !== children || $[12] !== href) {
    t1 = <Link prefetch={false} href={href} className={blockClass}>{children}</Link>;
    $[10] = blockClass;
    $[11] = children;
    $[12] = href;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== heightClass || $[15] !== t1) {
    t2 = <section className={heightClass}>{t1}</section>;
    $[14] = heightClass;
    $[15] = t1;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
};